@if (!cookieLawSeen) {
    <div class="cookiew-law-banner">
        <div class="banner-content">
            <span translate>
                This webservice uses cookies to find articles and give you a better overall user experience. Cookies are
                mainly used for traffic monitoring and content optimization. Learn more about Our terms of service
            </span>
            <a target="_blank" class="pointer" href="https://www.zisson.com/privacy-statement/" translate>here</a
            ><span>. </span>
            <span translate
                >You accept these terms by closing banner, clicking button Accept or by continuing browsing
                otherwise.</span
            >
            <button
                class="btn btn-close btn-transparent"
                (click)="closeBanner()"
                [attr.aria-label]="'Close' | translate">
                <sb-inline-svg
                    class="icon icon-close"
                    [url]="'sb-tools/theme/images/round-close-icon.svg'"></sb-inline-svg>
            </button>
            <div class="button-line clearfix">
                <button class="btn btn-accept" (click)="closeBanner()" translate>Accept</button>
            </div>
        </div>
    </div>
}
